import React from 'react'
import { Link } from 'react-router-dom'
import { generalIcons, requirementCardIcons } from '../../utils/constants'
import RequirementCard from '../../components/cards/RequirementCard'
import { Button } from '../../components'

function BecomeValidator() {
    return (
        <div className="relative min-h-screen h-full pb-16 lg:pb-[100px]">
            <div className="max-w-container px-3 lg:px-[25px] xl:px-[33px] m-auto flex items-center">
                <Link
                    to={"/"}
                    className="flex items-center -tracking-08 w-fit text-xsm font-medium text-dim"
                >
                    <div className='flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full'>
                        {generalIcons.backArrow}
                    </div>
                    <span className='opacity-[50%] mr-1'>Overview / </span>
                </Link>
                <span className='text-xsm'>Become a validator</span>
            </div>

            <div className="relative mt-[44px]">
                <div className="max-w-[1500px] mx-auto px-4">
                    <h1 className="text-[30px] md:text-[64px] text-textcolor font-bold lg:-tracking-37 leading-none md:leading-[64px] mb-3 text-center">
                        Become a Validator
                    </h1>
                    <p className="text-sm md:text-base leading-6 md:leading-7 -tracking-1 font-normal text-dim/50 text-center">
                        Secure the network and earn rewards by running a validator node.
                    </p>
                    <div className="w-full mt-[30px] md:mt-[60px] rounded-3xl bg-[#121212] border border-[#1A1A1A] pt-8 md:pt-10 p-4 md:p-7">
                        <h2 className="text-xl md:text-[34px] text-textcolor font-semibold leading-none md:leading-[34px] -tracking-[1.36px] mb-3 text-center">
                            Get Ready to Validate (Requirements)
                        </h2>
                        <p className="text-xsm md:text-sm leading-6 md:leading-7 -tracking[0.8px] font-normal text-dim/50 text-center max-w-[350px] md:max-w-[600px] mx-auto">
                            To run a validator node, you must have the right hardware, software, and network infrastructure. Review the details below.
                        </p>

                        <div className="grid lg:grid-cols-2 gap-8 my-7 md:my-10">
                            <div className="col-span-1">
                                <RequirementCard
                                    icon={requirementCardIcons.hardware}
                                    title="Hardware"
                                    firstListLeftSideText="- CPU"
                                    firstListRightSideText="Minimum 4-core processor"
                                    secListLeftSideText="- RAM"
                                    secListRightSideText="16 GB or more"
                                    thirdListLeftSideText="- Storage"
                                    thirdListRightSideText="SSD with at least 500 GB free space"
                                />
                            </div>
                            <div className="col-span-1">
                                <RequirementCard
                                    icon={requirementCardIcons.software}
                                    title="Software"
                                    firstListLeftSideText="- Operating System"
                                    firstListRightSideText="Linux (Ubuntu 20.04 or higher recommended)"
                                    secListLeftSideText="- Validator Node Software"
                                    secListRightSideText="Vanar Node Client"
                                    thirdListLeftSideText="- Security"
                                    thirdListRightSideText="Firewall and antivirus protection"
                                />
                            </div>
                            <div className="col-span-1">
                                <RequirementCard
                                    icon={requirementCardIcons.network}
                                    title="Network"
                                    firstListLeftSideText="Stable, high-speed internet connection"
                                    firstListRightSideText="Minimum 4-core processor"
                                    secListLeftSideText="Static IP address"
                                    thirdListLeftSideText="- Minimum upload/download speed"
                                    thirdListRightSideText="100 Mbps"
                                />
                            </div>
                            <div className="col-span-1">
                                <RequirementCard
                                    icon={requirementCardIcons.financial}
                                    title="Financial"
                                    firstListLeftSideText="Annual fees or hosting costs"
                                    secListLeftSideText="- Minimum Stake"
                                    secListRightSideText="10,000 VANAR tokens"
                                />
                            </div>
                        </div>

                        <h3 className="text-base md:text-[32px] text-textcolor font-semibold leading-none md:leading-[32px] -tracking-[1.28px] mb-5">
                            Details on
                        </h3>
                        <div className='flex items-center justify-between flex-col md:flex-row gap-4'>
                            <Button className="primary-gradient md:!font-medium py-[15px] md:py-3 px-4 gap-3 w-full md:w-auto" onClick={()=>{
                                window.open("https://forms.gle/d1v3dotjK3EnhAHi9","_blank")
                            }}>
                                See Full Requirements
                                <span className='w-4 h-4 flex items-center justify-center'>{generalIcons.externalLinkArrow}</span>
                            </Button>
                            {/* <Button className="bg-green/[0.10] md:!font-medium text-green py-[15px] md:py-3 px-4 gap-3 w-full md:w-auto">
                                Continue
                                <span className='flex items-center justify-center'>{generalIcons.rightArrow}</span>
                            </Button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BecomeValidator
